import { ChangeDetectionStrategy, Component, inject, Input, signal, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { FileResponse, SwaggerResponse } from 'src/app/client-api.service';
import { ImagesService } from 'src/app/shared/image-service';

@Component({
  selector: 'app-image-thumbnail',  
  templateUrl: './image-thumbnail.component.html',
  styleUrl: './image-thumbnail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ImageThumbnailComponent {
@Input() imageId!: number;

  private imagesService = inject(ImagesService);
  private sanitizer = inject(DomSanitizer);
  private sub?: Subscription;
  private lastObjectUrl?: string;

  imageUrl?: SafeUrl;
  imageUrl2 = signal<SafeUrl | undefined>(undefined);
  error: string | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['imageId'] && this.imageId !== undefined && this.imageId !== null) {
      this.loadImage();
    }
  }

  private loadImage() {    
    if (this.lastObjectUrl) {
      URL.revokeObjectURL(this.lastObjectUrl);
      this.lastObjectUrl = undefined;
    }
    this.imageUrl = undefined;
    this.imageUrl2.set(undefined);
    this.error = null;
    
    this.sub?.unsubscribe();

    this.sub = this.imagesService.getImageThumbnail(this.imageId).subscribe({
      next: (resp: SwaggerResponse<FileResponse>) => {
        if (resp.result?.data) {
          this.lastObjectUrl = URL.createObjectURL(resp.result.data);
    
          this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(this.lastObjectUrl);
          this.imageUrl2.set(this.sanitizer.bypassSecurityTrustUrl(this.lastObjectUrl));
        } else {
          this.error = 'No image data returned.';
        }
      },
      error: err => {
        this.error = 'Could not load image.';
      }
    });
  }

  ngOnDestroy() {
    if (this.lastObjectUrl) {
      URL.revokeObjectURL(this.lastObjectUrl);
    }
    this.sub?.unsubscribe();
  }
}
